import type { Store } from '../../types';
import type { SystemState } from '../reducer/v2/system';

export const getSystem = (state: Store): SystemState => state.system;
export const getCurrentStep = (state: Store): string =>
  state.system.currentStep;

export const getUtmSource = (state: Store): string => state.system.utmSource;
